import { bl_inv_pdg_hdr_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';
import { InventoryPdgOutletSizeFilterLinkContainerModel } from '../inventory-pdg-outlet-size-filter-link';
import { InventoryPdgOutletTypeFilterLinkContainerModel } from '../inventory-pdg-outlet-type-filter-link';
import { LabelHdrGuidPairDto } from './label-hdr-guid-pair-dto.model'
export class InventoryPdgContainerModel extends BaseContainerModel {
  bl_inv_pdg_hdr: bl_inv_pdg_hdr_RowClass = new bl_inv_pdg_hdr_RowClass();
}


export class PdgFilterLinksReqContainerModel {
  outletTypeFilterLinkContainers: Array<InventoryPdgOutletTypeFilterLinkContainerModel>;
  outletSizeFilterLinkContainers: Array<InventoryPdgOutletSizeFilterLinkContainerModel>;
  container: InventoryPdgContainerModel;
  pairLabelHdrGuids: Array<LabelHdrGuidPairDto>;

}